import { ApplicationRef, Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';

@Injectable({
  providedIn: 'root'
})
export class ServiceWorkerService {

  constructor(private updates: SwUpdate, private appRef: ApplicationRef) {

    this.updates.activated.subscribe(event => {
      console.log('old version was', event.previous);
      console.log('new version is', event.current);
    });
    this.updates.available.subscribe(event => {
      console.log('current version is', event.current);
      alert("Neues Update muss installiert werden. Die Applikation wird neu geladen.");
      this.updates.activateUpdate().then(() => document.location.reload());
      console.log('available version is', event.available);
    });
  }

  isEnabled(): boolean {
    return this.updates.isEnabled;
  }

  checkForUpdates(): Promise<boolean> {

    return this.updates.checkForUpdate();
  }
}
